/**
 * The phone's status bar — and an installed PWA's title bar — takes the page's
 * `<meta name="theme-color">`. HQ keeps it the colour of the library AppLayout's
 * app bar (renderApp's ReactiveThemeProvider calls this with the live
 * `palette.primary.main`), so the two never disagree when a user picks another
 * colour scheme. index.html and pwaManifest.ts carry the default (`#0057B8`)
 * for the moment before the app runs.
 */

/** The slice of `Document` this needs — lets the unit test pass a fake. */
export interface ThemeColorDocument {
  querySelector(selector: string): { content: string } | null;
  createElement(tag: "meta"): { name: string; content: string };
  head: { appendChild(node: unknown): unknown };
}

/** Point `<meta name="theme-color">` at `color`, creating the tag if absent. */
export function syncThemeColorMeta(color: string, doc: ThemeColorDocument = document): void {
  let meta = doc.querySelector('meta[name="theme-color"]');
  if (!meta) {
    const created = doc.createElement("meta");
    created.name = "theme-color";
    doc.head.appendChild(created);
    meta = created;
  }
  if (meta.content !== color) meta.content = color;
}
